import { LogReportObj } from "utils/types/general.types";

export const logReportData: LogReportObj[] = [
    {
        id: 1,
        name: "No of registered users",
        count: 50
    },
    {
        id: 2,
        name: "No of users",
        count: 50
    },
    {
        id: 3,
        name: "No of blocked users",
        count: 50
    },
    {
        id: 4,
        name: "No of deleted users",
        count: 50
    },
    {
        id: 5,
        name: "No of groups",
        count: 50
    },
    {
        id: 6,
        name: "No of blocked group",
        count: 50
    },
    {
        id: 7,
        name: "No of deleted group",
        count: 50
    },
    {
        id: 8,
        name: "Total no of post till now 2023 - 2024",
        count: 50
    },
    {
        id: 9,
        name: "Total no of incidents till now 2023 - 2024",
        count: 50
    }
];
